import  { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Bplay, CurrentAudioRef, CurrentAudioUrl, Repeat, CurrentDuration, Medias, IsMusicComponent, Cposition, DurFlag, MediaFile } from "../global";
import { IonFabButton, isPlatform } from "@ionic/react";
import { StopSharp } from "@mui/icons-material";
import audioFile from '../../dum.mp3';
import { MediaSession } from "@jofr/capacitor-media-session"

function AudioPLayer(props) {
    let history = useHistory();
    const [bplay, ] = useContext(Bplay);
    const [repeat, ] = useContext(Repeat)
    const currentAudioRef = useContext(CurrentAudioRef);
    const [currentAudioUrl, setCurrentAudioUrl] = useContext(CurrentAudioUrl);
    const [ppb, setPpb] = useContext(Medias)
    const [, setCurrentDuration] = useContext(CurrentDuration)
    const [isMusicComponent, ] = useContext(IsMusicComponent)
    let location = useLocation(); 
    const [durFlag, ] = useContext(DurFlag)
    const [, setCposition] = useContext(Cposition)
    const [mediaFile, ] = useContext(MediaFile)

    useEffect(()=>{
      if(!ppb) {
        MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
      }
   }, [location])

   useEffect(()=>{
    if (durFlag) {
    let sprog = setInterval(
      () => {
       
        mediaFile.getCurrentPosition().then((position)=>{
         if(position >= 0){
          setCposition(position);
          MediaSession.setPositionState({"position": position, "duration": mediaFile.getDuration()})
         } 
         if (mediaFile.getDuration() - position <= 1) {
          if (bplay.fold) {
            history.push("/lists/" + (!isNaN(bplay.fold) ? bplay.fold - 1 : bplay.fold));
          } else {
           if (repeat === "yes") {
            mediaFile.seekTo(1);
           } else{
            setPpb(false);
            if(currentAudioRef.current) currentAudioRef.current.pause();
            MediaSession.setPlaybackState({playbackState:"paused"}).catch((err)=>{console.error(err)})
           } 
          }
         }
        })
      },
      1000
     );
     return(()=>{clearInterval(sprog)})
    }
   }, [durFlag, mediaFile])
    


    return(
        <>
            {ppb && !isMusicComponent ? <div style={{ position: "fixed", left: "50%", bottom: `${isPlatform("ios") ? "64px" : "30px"}`, zIndex: 100000, transform: "translate(-50%, -50%)" }}>
    <IonFabButton
    onClick={() => {
        MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
        if(mediaFile) mediaFile.pause()
        if(currentAudioRef.current) currentAudioRef.current.pause();
        setCurrentAudioUrl(null)
        setPpb(false)
    }}
    color={props.colorh}
    style={{ opacity: "50%" }}
    >
       <StopSharp />
    </IonFabButton>
    </div>: null}
        <audio
        loop={durFlag ? true : false}
        onEnded={() => {
          if(!durFlag){
         if (bplay.fold) {
          history.push("/lists/" + (!isNaN(bplay.fold) ? bplay.fold - 1 : bplay.fold));
         } else {
          if (repeat === "yes") {
           if (currentAudioRef.current) currentAudioRef.current.play();
          } else{
            setPpb(false);
            MediaSession.setPlaybackState({playbackState:"paused"}).catch((err)=>{console.error(err)})
          } 
         }
        }
        }}
        onTimeUpdate={() => {
          if(!durFlag){
         if(isMusicComponent){
          setCurrentDuration(currentAudioRef.current.currentTime);
         }
         if(currentAudioRef.current.duration) MediaSession.setPositionState({"position": currentAudioRef.current.currentTime, "duration": currentAudioRef.current.duration})
        }
        }}
        ref={currentAudioRef}
        src={durFlag ? audioFile : currentAudioUrl }
       >
        Your browser does not support the audio element.
       </audio>
       </>
    )
}

export default AudioPLayer